import type { CoverArts, CoverArtsResponse } from './types';

export const mapCoverArts = (data: CoverArtsResponse): CoverArts => {
  return {
    defaultCoverArtImageUrl: data.default_cover_art_image_url,
    prayTvCoverArtImageUrl: data.pray_tv_cover_art_image_url,
    prayRadioCoverArtImageUrl: data.pray_radio_cover_art_image_url,
  };
};
